// extracted by mini-css-extract-plugin
export default {"noDataWrapper":"DashboardGraphs_noDataWrapper__x62ZX","noDataImage":"DashboardGraphs_noDataImage__cvATe"};